import logger from '../../log';
import { PlayType, SourceType } from '../../common/constants';
import { Item } from './interfaces';
import createInterceptorStack from '../../interceptor/createInterceptorStack';
import InterceptorStack from '../../interceptor/InterceptorStack';
import { HttpHeaders } from '../../interceptor/interfaces';
import { OidFunction } from '@kollective-frontend/ksdk-api';
import makeRequest from '../../interceptor/makeRequest';
import ContentConfig from '../../config/ContentConfig';

const log = logger.getLogger(__filename);

export default class SourceStack {
  stack: InterceptorStack;

  constructor(opts: {
    items: Item[];
    createObjectId?: OidFunction;
    config: ContentConfig;
    sourceType: SourceType;
    playType: PlayType;
    sdkVer: string;
    sessionToken: string;
    tenantId: string;
    contentId: string;
  }) {
    this.stack = createInterceptorStack(opts);
  }

  async sourceContent(
    requestingId: string,
    url: string,
    opts?: { headers: HttpHeaders }
  ): Promise<void> {
    const request = makeRequest('GET', url, opts);
    log.debug(`Sourcing on behalf of node ${requestingId} for:`, request);
    try {
      const resp = await this.stack.handle(request);
      log.debug('Sourced on behalf of node with resposne:', resp);
    } catch (e) {
      log.warn(
        `Failed to soruce on behalf of node ${requestingId} with error:`,
        e
      );
    }
  }
}
